export default "__VITE_ASSET__8661688c__"